// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"e8355b69","470":"ab160b00","641":"6b34d659","757":"043b7d92","978":"ed0295e4"}[chunkId] + ".chunk.js";
};